import { render } from "./index.vue?vue&type=template&id=6cd131cd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6cd131cd&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd131cd"],['__file',"src/components/VoltarAoTopo/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cd131cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cd131cd', __exports__)) {
    console.log('reload')
    api.reload('6cd131cd', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6cd131cd&scoped=true", () => {
    console.log('re-render')
    api.rerender('6cd131cd', render)
  })

}


export default __exports__